import { PRODUCT_AREA } from '@leagueplatform/analytics';
import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useLocation } from 'react-router-dom';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useCommonPageSetup } from '@scfhp-web/shared-module';

const useQueryParams = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};

export const FormStatusDetailsPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: 'STR_SUBMITTED_REQUESTS' });
  useCommonPageSetup({ title, productArea: PRODUCT_AREA.GET_CARE });

  const params = useQueryParams();
  const formId = params.get('formId') || '';

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
        '.GDS-composable-card': {
          boxShadow: 'none !important',
        },
        '.GDS-composable-card .GDS-heading-text': {
          fontSize: '$headingThree',
          lineHeight: '$headingThree',
          fontWeight: '$headingThree',
        },
      }}
    >
      <StackLayout
        orientation="vertical"
        css={{
          width: '100%',
          maxWidth: '894px',
          margin: '0 auto',
          gap: '12px',
        }}
      >
        {/* Position parent for Masonry's absolutely-positioned loading spinner. */}
        <Box
          css={{
            position: 'relative',
            width: '100%',
            minHeight: 'calc(100vh - 300px)',
          }}
        >
          {/* Web mounts `rootWeb`; iOS/Android mount `formStatusDetail$root` (bottom-anchored CTA). */}
          <Masonry
            rootNodeId="formStatusDetail$rootWeb"
            initialQueryParams={{ formId }}
          />
        </Box>
      </StackLayout>
    </MainPageContainer>
  );
};
